import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import "./welcome.sass";
import { useNavigate } from "react-router-dom";
import { BASE } from "../basedata/constants";

const OptInPage = () => {
  const { t } = useTranslation(); 
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();

  const handleAcceptTerms = () => {
    sessionStorage.setItem('user_optin', 'true');
    navigate("/signup");
  };

  const handleContinue = () => {
    if (accepted) {
      navigate("/signup");
    }
  }

  const initialized = useRef(false)
  useEffect(() => {

    if (!initialized.current) {

      const params = new URLSearchParams(window.location.search)
      const currentToken = params.get('token'),
      currentCompany = params.get('orc')
  
    if(currentToken){
      sessionStorage.setItem('token', `${currentToken}`)
      sessionStorage.setItem('originCompany', `${currentCompany}`)
      window.location.href = `/validating?token=${currentToken}`
      
    }
  
    initialized.current = true

  }
  }, [])


  return (

    <div className="main-container">
      <div className="left-side"></div> 
      <div className="right-side">
        <div className="success-card">
          <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
          <h1 className="bepass-title">{t("user_optin_page.title")}</h1>
          <p className="bepass-text-default bepass-optin-text">
            <Trans i18nKey="user_optin_page.message"
            values={{ company_name: BASE.company.name, company_contact_mail:  BASE.company.dpo_email}}
            />
          </p>

  <button onClick={() => handleAcceptTerms()} className="continue-button optin-button"
    >
      {t("user_optin_page.action_agree")}
    </button>

    <button onClick={() => {window.location.href = '/opt-contact'}} className="continue-button btn-ghost"
    >
    {t("user_optin_page.action_disagree")}
    </button>

        </div>
      </div>
      {/* <footer className="success-footer">
        <div className="success-footer-logo"></div>
      </footer> */}
    </div>
  );
};

export default OptInPage;

